import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { Tab } from '@iv/model/tabs.model';
import {
  CdkDragDrop,
  moveItemInArray
} from '@angular/cdk/drag-drop';
import {PaymentWindowService} from '../../../payment-window.service';

@Component({
  selector: 'iv-live-tab-panel',
  templateUrl: './tab-panel.component.html',
  styleUrls: ['./tab-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class TabPanelComponent implements OnInit, OnChanges {

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef,
    private paymentWindowService: PaymentWindowService
  ) {
  }

  private static RIGHT_MARGIN = 3;
  private static ADD_NEW_TAB_BUTTON_WIDTH = 30;
  private static MIN_TAB_WIDTH = 120;
  private static MAX_TAB_WIDTH = 200;

  @HostBinding('class') @Input() class = '';
  @ViewChild('tabContainer', {static: false}) tabContainer !: ElementRef;

  @Input() tabs: Tab[];
  @Output() selected = new EventEmitter<any>();
  @Output() closed = new EventEmitter<any>();
  @Output() orderChanged = new EventEmitter<any>();
  @Output() openNewTabClicked = new EventEmitter<any>();

  tabWidth = 200;
  showScrollButton = false;
  public left = 0;
  public isEditTitle: boolean = false;

  public get chartServiceBlink(): boolean {
    return JSON.parse(localStorage.getItem('chart-service-blink'));
  }

  ngOnInit() {
    this._countColumnWidth();
    if (!this.chartServiceBlink && localStorage.getItem('chart-service-blink') !== null) return;
    localStorage.setItem('chart-service-blink', 'true');
  }

  ngOnChanges(changes: SimpleChanges) {
    const tabs = changes.tabs;
    if (tabs) {
      this._changeTabs(tabs.previousValue, tabs.currentValue);
    }
  }

  public onSelectTab(index: number, tab: Tab): void {
    if (tab.type === 'chartService') {
      localStorage.setItem('chart-service-blink', 'false');
    }

    if (!tab.active) {
      this.selected.emit(index);
    }
  }

  onCloseTab(index) {
    this.closed.emit(index);
    this._countColumnWidth();
  }

  onOpenNewTabClick() {
    this.paymentWindowService.showPaymentWindow();
    this.openNewTabClicked.emit();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.tabs, event.previousIndex, event.currentIndex);
    this.orderChanged.emit(this.tabs);
  }

  scrollLeft(tabContainer: HTMLDivElement) {
    const tabWidth = this.tabWidth + TabPanelComponent.RIGHT_MARGIN;
    const containerWidth = tabContainer.clientWidth;
    if (this.left % tabWidth === 0) {
      if (this.left !== 0) {
        this.left = this.left + tabWidth;
      }
    } else {
      if (-this.left < tabWidth) {
        this.left = 0;
      } else {
        this.left = this.left + (tabWidth - (containerWidth % tabWidth)) + tabWidth;
      }
    }
  }

  scrollRight(tabContainer: HTMLDivElement) {
    const tabWidth = this.tabWidth + TabPanelComponent.RIGHT_MARGIN;
    const containerWidth = tabContainer.clientWidth;
    if (tabWidth * this.tabs.length !== containerWidth + (-this.left)) {
      if (this.left % tabWidth === 0) {
        this.left = this.left - (tabWidth - (containerWidth % tabWidth));
        if ((Math.ceil(containerWidth / tabWidth) < this.tabs.length)) {
          this.left = this.left - tabWidth;
        }
      } else {
        if (Math.ceil((this.left + containerWidth) / tabWidth) !== this.tabs.length) {
          this.left = this.left - tabWidth;
        }
      }
    }
  }

  isRightArrowDisabled(tabContainer: HTMLDivElement) {
    const tabWidth = this.tabWidth + TabPanelComponent.RIGHT_MARGIN;
    const containerWidth = tabContainer.clientWidth;
    return (tabWidth * this.tabs.length === containerWidth + (-this.left));
  }

  private _countColumnWidth() {
    const maxTabWidth = TabPanelComponent.MAX_TAB_WIDTH + TabPanelComponent.RIGHT_MARGIN;
    const minTabWidth = TabPanelComponent.MIN_TAB_WIDTH + TabPanelComponent.RIGHT_MARGIN;
    const tabsContainerWidth = this.elementRef.nativeElement.clientWidth - TabPanelComponent.ADD_NEW_TAB_BUTTON_WIDTH;
    const maxTabsWidth = this.tabs.length * maxTabWidth;
    if (tabsContainerWidth >= maxTabsWidth) {
      this.tabWidth = TabPanelComponent.MAX_TAB_WIDTH;
    } else if ((tabsContainerWidth / this.tabs.length) > minTabWidth) {
      const commonMargin = this.tabs.length * TabPanelComponent.RIGHT_MARGIN;
      this.tabWidth = (tabsContainerWidth - commonMargin) / this.tabs.length;
    } else {
      this.tabWidth = TabPanelComponent.MIN_TAB_WIDTH;
    }
    this.showScrollButton = (this.tabWidth === TabPanelComponent.MIN_TAB_WIDTH);
  }

  private _changeTabs(prevTabs, tabs) {
    this.tabs = tabs;
    if (prevTabs && tabs && prevTabs.length !== tabs.length) {
      this._countColumnWidth();
      if (tabs.length > prevTabs.length) {
        this._scrollToActive();
      }
    }
  }

  private _scrollToActive() {
    const tabWidth = this.tabWidth + TabPanelComponent.RIGHT_MARGIN;
    const tabsWidth = this.tabs.length * tabWidth;
    const containerWidth = this.elementRef.nativeElement.clientWidth;
    if (tabsWidth > containerWidth) {
      const activeTabIndex = this._getActive();
      const tabsToActiveWidth = (activeTabIndex + 1) * tabWidth;
      if (this._getActive() === (this.tabs.length - 1)) {
        this.left = (containerWidth - 90) - tabsWidth;
      } else if (tabsToActiveWidth > containerWidth) {
        this.left = (containerWidth - 90) - tabsToActiveWidth;
      }
    }
  }

  private _getActive() {
    return this.tabs.findIndex(tab => {
      return tab.active;
    });
  }

  public saveTitle(): void {
    // Записываем все текущие табы (в неизменённом порядке) в store для сохранения названия вкладки
    this.orderChanged.emit(this.tabs);
  }

  public onEditTitle(isEditTitle: boolean): void {
    this.isEditTitle = isEditTitle;
  }
}
